import { colors } from "../../common/colors";

export const styles = {
  errorMessage: {
    backgroundColor: colors.farm_gray15,
    margin: "0",
    padding: "5px",
  },

  inputField: {
    backgroundColor: colors.farm_white,
    width: "100%"
  },

  textField: {
    marginTop:
    "15px",
    background: colors.farm_white,
    width: "100%"
  },

  typographyText: {
    borderBottomColor: colors.farm_green500,
    borderBottomWidth: 2,
    borderBottomStyle: "solid" as const,
    paddingTop: "50px",
    textAlign: "left",
    fontSize: "15px",
  },
  radioLabel: {
    "& .MuiFormControlLabel-label": { fontWeight: "bold" }
  },
}
